import * as React from 'react';
import { useState } from 'react';
import b_ from 'b_';
import { useTranslation } from 'react-i18next';
import { getPartners } from '../../partners';
import Item from './components/Item';
import Slider from './components/Slider';

import './index.scss';

const b = b_.with('main-page-partners-list');

const SLIDES_COUNT = 4;

const List: React.FC = () => {
  const { t } = useTranslation();
  const [currentSlide, setCurrentSlide] = useState<number | null>(null);
  const partners = getPartners(t);

  return (
    <div className={b()}>
      {partners.map((partner, index) => (
        <Item
          key={index}
          partner={partner}
          big={index < SLIDES_COUNT}
          onClick={() => {
            index < SLIDES_COUNT && setCurrentSlide(index);
          }}
        />
      ))}
      <div className={b('more')}>
        {t('and (more)')}
        <span>100+</span>
        {t('people')}
      </div>
      {currentSlide !== null && (
        <Slider count={SLIDES_COUNT} index={currentSlide} onClose={() => setCurrentSlide(null)} />
      )}
    </div>
  );
};

export default List;
